module.exports = "pegasus_template/assets/themelp1/basic/101.png";